// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MarkAsPaidModal-module__radioGroup--Rk4KqY7y{display:flex;flex-direction:column;gap:16px}", "",{"version":3,"sources":["webpack://./src/features/markAsPaidModal/ui/markAsPaidModal/MarkAsPaidModal.module.scss"],"names":[],"mappings":"AAAA,8CACE,YAAA,CACA,qBAAA,CACA,QAAA","sourcesContent":[".radioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioGroup": "MarkAsPaidModal-module__radioGroup--Rk4KqY7y"
};
export default ___CSS_LOADER_EXPORT___;
